module.exports = __webpack_public_path__ + "static/media/ct-triangle.91c0abf7.svg";